<div
  class="d-flex flex-column flex-md-row align-items-center align-items-stretch justify-content-between mb-4 gap-4"
>
  <div>
    <img
      [src]="
        course_item.course_image_url
          ? fileUrl + course_item.course_image_url
          : ''
      "
      class="w-125px h-100px object-fit-cover rounded"
    />
  </div>
  <div class="d-flex flex-row flex-grow-1 align-items-center">
    <div class="flex-grow-1 d-flex flex-row justify-content-between">
      <div class="flex-grow-1">
        <p
          class="fw-bolder text-gray-800 text-hover-primary fs-4 mb-0 product-name text-overflow-line-1"
        >
          {{ course_item?.course_name }}
        </p>
        <p class="text-muted fw-semibold mb-4 fs-6">
          {{ course_item?.course_tutors[0]?.tutor_name || "" }}
        </p>
        <p class="text-gray-700 fw-bold mb-0 fs-6">
          <!-- A free course showed as "฿0.00", which reads as a pricing bug.
               The catalogue card and the course page both say "เรียนฟรี". -->
          @if ((course_item?.course_price || 0) > 0) {
          {{ course_item?.course_price | currency : "฿" }}
          } @else {
          <span class="text-success">{{ "APP.FREE" | translate }}</span>
          }
        </p>
      </div>

      <!-- Label and value in one stack, right-aligned and vertically centred.
           `justify-content-between` on a column as tall as the thumbnail put
           "จำนวน" up on the product's title line — where it read as part of the
           name — and its value 75px below it. -->
      <div
        class="d-none d-md-flex flex-column align-items-end justify-content-center px-4"
      >
        <span class="fs-7 text-muted lh-sm">
          {{ "APP.AMOUNT" | translate }}
        </span>
        <span class="fs-4 fw-semibold lh-sm">
          {{ course_item?.amount }}
        </span>
      </div>
      @if(can_delete){

      <!-- Centred on the row, and with resting chrome: `btn-active-light-*`
           paints nothing until pressed, so this was a bare grey glyph. -->
      <div class="d-flex align-items-center ps-4">
        <button
          #deleteBtn
          class="btn btn-icon btn-light w-32px h-32px ms-0"
          (click)="deleteItem(course_item.course_id)"
        >
          <app-keenicon
            name="trash"
            class="fs-3 svg-icon svg-icon-2 cursor-pointer"
          ></app-keenicon>
        </button>
      </div>
      }
    </div>
  </div>
</div>
